import React, { ReactNode } from 'react';
import clsx from 'clsx';
interface ContentLayoutHeaderProps {
  children: ReactNode;
}

/**
 * @desc ContentLayoutHeader
 * @param children
 * @return {JSX.Element}
 * @constructor
 */
function ContentLayoutHeader({
  children,
}: ContentLayoutHeaderProps): JSX.Element {
  return (
    <div className="sticky top-0 z-20 flex min-h-20 bg-background pb-4">
      {children}
    </div>
  );
}

ContentLayoutHeader.displayName = 'ContentLayoutHeader';

interface ContentLayoutContentProps {
  children: ReactNode;
}

/**
 * @desc ContentLayoutContent
 * @param children
 * @return {JSX.Element}
 * @constructor
 */
function ContentLayoutContent({
  children,
}: ContentLayoutContentProps): JSX.Element {
  return <div className="h-full">{children}</div>;
}

ContentLayoutContent.displayName = 'ContentLayoutContent';

interface ContentLayoutProps {
  children: ReactNode;
  scrollable?: boolean;
}

/**
 * @desc ContentLayout
 * @param children
 * @return {JSX.Element}
 * @constructor
 */
function ContentLayout({
  children,
  scrollable = true,
}: ContentLayoutProps): JSX.Element {
  let header: ReactNode = null;
  let content: ReactNode = null;

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      if ((child.type as any).displayName === 'ContentLayoutHeader') {
        header = child;
      } else if ((child.type as any).displayName === 'ContentLayoutContent') {
        content = child;
      }
    }
  });

  return (
    <div className="flex h-full w-full flex-1 flex-col overflow-hidden">
      <div className="h-full flex-1">
        <div className="mx-auto flex h-full flex-col">
          {header}
          <div
            className={clsx(
              'relative flex-1 overflow-auto rounded-md border bg-white shadow-sm',
              scrollable && 'overflow-auto'
            )}
          >
            <div className="flex h-full flex-col">{content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

ContentLayout.Header = ContentLayoutHeader;
ContentLayout.Content = ContentLayoutContent;

export default ContentLayout;
